module.exports = __webpack_public_path__ + "static/media/openart.0dc4cb4d.jpg";